import { QueryObserverResult, UseQueryOptions, useQuery } from '@tanstack/react-query';
import { GetExceptionLogDetailsRequest, GetExceptionLogDetailsResponse } from '../fragments';
import { API_QUERY_KEYS, QueryDefaults } from 'api/constants';
import { getExceptionLogDetails } from '../methods/getExceptionLogDetails';

export const useExceptionLogDetails = (
  request: GetExceptionLogDetailsRequest,
  options?: UseQueryOptions<GetExceptionLogDetailsResponse>
): QueryObserverResult<GetExceptionLogDetailsResponse> => {
  return useQuery<GetExceptionLogDetailsResponse>(
    [API_QUERY_KEYS.getExceptionLogDetails, request],
    () => getExceptionLogDetails(request),
    {
      ...QueryDefaults,
      ...options,
      onSuccess: (data: GetExceptionLogDetailsResponse) => data,
      onError: (err: unknown) => ({
        err,
      }),
    }
  );
};
